import React from "react";
import { ErrorState } from "../Types";

export interface ErrorProps {
  error?: string | ErrorState<any> | null;
}

export const Error: React.FC<ErrorProps> = (props) => {

    const iterate = (error : ErrorState<any>, strs: string[]) => {
        for(let p in error) {
            let v = error[p];
            if(!v) {
                continue;
            }
            if(typeof v == "string") {
                strs.push(v);
                continue;
            }
            iterate(v, strs);
        }
    }

    if(!props.error) {
        return <></>
    }
    else if(typeof props.error == "string") {
        return <span>{props.error}</span>
    }
    else {
        let strs: string[] = [];
        iterate(props.error, strs);
        return <>
            {strs.map((e,i)=> <span key={i}>{e}<br/></span>)}
        </>
    }
}